import * as React from "react";
import { ProductValuationDetailSummary } from "../../../../../../../../Wrap/Models/Domains/Valuation/ProductValuationDetailSummary";
import { Methods } from "../../../../../../Common/CommonHelper";
import { RegularPaymentIn } from "../../../../../../../../Wrap/Models/Domains/Valuation/RegularPaymentIn";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { Guid } from "../../../../../../../../react-core/Utils/Guid";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { Money } from "../../../../../../../../Wrap/Core/DataTypes/Money";
import { RegularPaymentType } from "../../../../../../../../Wrap/Constants/Enums/Domain/RegularPaymentType";
import { FrequencyType } from "../../../../../../../../Wrap/Constants/Enums/Domain/FrequencyType";
import { RegularWithdraw } from "../../../../../../../../Wrap/Models/Domains/Valuation/RegularWithdraw";
import { DashboardContents } from "../../../../../../Resoures/DashboardContents";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { StaticUrls } from "../../../../../../Resoures/StaticUrls";
import { ClientAccountStore, UserStore } from "../../../../../../Stroes/Variable";
import { CashPopupView } from "./CashPopupView";
import { SubAccountTypeHelper } from "../../../../Common/Helpers/SubAccountTypeHelper";
import { accountStatusMap } from "../../../../ClientRecord/Resource/Contents";
import { InvalidateDate } from "../../../../../../../../react-core/Datepicker/Resources/ContentContent";
import { getQueryParameters } from "../../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Lightbox, LightboxType } from "../../../../../../../../react-core/Html/Components/Lightbox";
import { Permission } from "../../../../../../../Shared/Permission/Permission";
import { UserClaim } from "../../../../../../../../Wrap/Constants/Enums/UserClaim";
import { Urls } from "../../../../../../Urls";
import { CommonHelper } from "../../../../../../../../react-core/Helpers/CommonHelper";
import { ThreeDotsDrodpwn } from "./ThreeDotsDropdown";
import { Navigator } from "../../../../../../../Shared/Wizards/Entities/Navigator";
import { ContextStore } from "../../../../../../../../react-core/Flux/Variables";
import { ContextType } from "../../../../../../../../Wrap/Constants/Enums/ContextType";
import { PresentationContext } from "../../Common/PresentationViewWrapper";
import { Action } from "../../../../../../../Dashboard/Actions/Action";
import { SippIncome } from "../../../../../../../../Wrap/Models/Domains/Valuation/SippIncome";
import { MoneyHelper } from "../../../../../../../Shared/Common/MoneyHelper";
import { Frequency } from "../../../../../../../../Wrap/Constants/Enums/Domain/Frequency";
import CoachMarker from "../../../../../../../Shared/CoachMarkers/CoachMarker";
import { User } from "../../../../../../../../Wrap/Models/Models/User/User";
import { BaseComponent } from "../../../../../../../../react-core/Html/BaseComponent";
import { SippIncomeDispatcher, SippIncomeStore, SummaryTrustDetailsStore } from "../Store/Variable";
import { TrustDetail } from "../../../../../../../../Wrap/Models/Domains/Account/TrustDetail";
import { AccountStatus } from "../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/AccountStatus";
import { PortfolioDashboardStore } from "../../../Store/Variable";
import AdviserSiteTagManager, {
    eventCategoryForGTM,
} from "../../../../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";
import { PortfolioDashboardSummaryAction } from "../Action/Action";
import { ActionType } from "../../../../../../../../react-core/Flux/ActionType";
import { RestrictionReasonStore } from "../../../Store/Variables";
import { RestrictionReason } from "../../../../../../../../Wrap/Models/Models/Account/Restrictions/RestrictionReason";
import { PensionLevelDrawdownIncome } from "../../../../../../../../Wrap/Models/Domains/Drawdown/PensionLevelDrawdownIncome";
import { DrawdownAnnualIncome } from "../../../../../../../../Wrap/Models/Domains/Drawdown/DrawdownAnnualIncome";
import { calculateGrossIncomePerPayment } from "../../../../Common/SIPP/IncomePaymentDetails/Helper/IncomePaymentHelper";
import { MoneyDisplayHelper } from "../../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { FrequencyTypeMap } from "../../../../../../Resoures/Contents";

interface IAccountCardProps extends React.Props<AccountCard> {
    index: number;
    product: ProductValuationDetailSummary;
    stringHelper: any;
    hasReadWriteAccessToAdviser: boolean;
}

interface IAccountCardState {
    userInfo?: User;
    hierarchyId: string;
    isShowCashModal: boolean;
    showLightbox: boolean;
    showWithDrawlRestrictionLightbox: boolean;
    sippIncome: SippIncome;
    sippDrawdownServiceFailure: boolean;
    trustDetail: TrustDetail[];
    restrictionReasons: RestrictionReason[];
    drawdownIncome?: PensionLevelDrawdownIncome
}

export class AccountCard extends BaseComponent<IAccountCardProps, IAccountCardState> {
    constructor(props: any) {
        super(props);
        this.state = {
            userInfo: UserStore.getUserInfo(),
            hierarchyId: "",
            isShowCashModal: false,
            showLightbox: false,
            showWithDrawlRestrictionLightbox: false,
            sippIncome: {
                CurrentIncome: MoneyHelper.getDefaultMoney(),
                IncomeFrequency: Frequency.NotSpecified,
                TaxCode: "",
                TaxRegime: "",
            },
            trustDetail: [],
            sippDrawdownServiceFailure: false,
            restrictionReasons:RestrictionReasonStore.getData()
        };
        this.subscribeToStore(SummaryTrustDetailsStore, () => this.onTrustDetailChange());
        this.subscribeToStore(SippIncomeStore, () => this.onSippIncomeChange());
        this.subscribeToStore(RestrictionReasonStore, () => this.onRestrictionReasonStoreChange());
    }

    private onSippIncomeChange(): void {
        const query = this.props.product.HeadAccountHierarchyId;
        const data = SippIncomeStore.getPayload(query);

        if (data != null && !SippIncomeStore.isLoadingForQuery(query)) {
            if (SippIncomeStore.isErrorForQuery(query)) {
                this.setState({ sippDrawdownServiceFailure: true });
            } else {
                this.setState({ sippIncome: data, sippDrawdownServiceFailure: false });
            }
        }
    }

    private onTrustDetailChange(): void {
        const result: TrustDetail[] = [];

        SummaryTrustDetailsStore.getAllPayload().forEach((item) => {
            result.concat(item.payload || []);
        });

        this.setState({ trustDetail: result });
    }

    private addEvent = new AdviserSiteTagManager().addEvent;

    componentDidMount() {
        const { product } = this.props;
        if (product?.ProductType == SubAccountType.Sipp) {
            if (SippIncomeStore.isEmptyForQuery(product.HeadAccountHierarchyId)) {
                PortfolioDashboardSummaryAction.getSippIncome(product.HeadAccountHierarchyId);
            } else {
                SippIncomeDispatcher.dispatch({
                    actionType: ActionType.Success,
                    payload: SippIncomeStore.getPayload(product.HeadAccountHierarchyId),
                    query: product.HeadAccountHierarchyId,
                });
            }
        }
        if (product?.ProductType && product?.SubAccountHierarchyId && this.state.drawdownIncome == null && SubAccountTypeHelper.isOnPlatformPension(product.ProductType)) {
            Action.getDrawdownIncome(product.SubAccountHierarchyId, (val) => {
                this.setState({ drawdownIncome: val })
            });
        }
    }

    private onRestrictionReasonStoreChange(): void {
        const data = RestrictionReasonStore.getData();
        this.setState({ restrictionReasons: data });
    }

    public render(): JSX.Element {
        const { product, index } = this.props;
        const { isPresentationView } = this.context;
        const accountTypeClass = this.props.stringHelper.getDonutClass(product.WrapperType, product.WrapperSubType); 
        const accountCardClass = "account-card d" + (index + 3);
        const containerClass = isPresentationView
            ? "center-text pl-60 pr-60 ml-60 mr-60"
            : "col-12 col-md-6 col-equalise";
        return (
            <div key={product.ClAccountId + index} className={containerClass}>
                <div className={accountCardClass}>
                    <div className="card-upper">
                        <div className={"card-heading " + accountTypeClass}>
                            <div className="row">
                                <div className="col-11" style={{ position: "relative" }}>
                                    {index === 0 && <CoachMarker coachMarkerKey="portfoliosummary-products" />}
                                    <span className={"account-legend " + accountTypeClass}></span>
                                    {product.ProductType != SubAccountType.Sipp && (
                                        <Permission
                                            userClaim={UserClaim.AdviserPortalClientInvestmentsCanView}
                                            replaceChildren={
                                                <a href={"javascript:void(0);"}> {product.ProductDisplayName}</a>
                                            }
                                        >
                                            <a
                                                className="hyperlink"
                                                href={"javascript:void(0);"}
                                                onClick={() => {
                                                    this.addEvent({
                                                        eventParameters: {
                                                            eventCategory: eventCategoryForGTM.summaryTab,
                                                            eventAction: "product details",
                                                            eventLabel: product.ProductDisplayName,
                                                        },
                                                        event: "summarytab_interaction",
                                                    });
                                                    Navigator.navigateTo(
                                                        Urls.get()
                                                            .main.PortfolioDashboard({
                                                                hierarchyId: ContextStore.getUrlParamsHierarchyId(
                                                                    ContextType.Customer
                                                                ),
                                                            })
                                                            .productOverView({
                                                                subaccounthierarchyId: product.SubAccountHierarchyId,
                                                            }).productOverView
                                                    );
                                                }}
                                            >
                                                {product.ProductDisplayName}
                                            </a>
                                        </Permission>
                                    )}

                                    {product.ProductType == SubAccountType.Sipp && (
                                        <Permission
                                            userClaim={UserClaim.AdviserPortalDluSippDetailCanView}
                                            replaceChildren={
                                                <a href={"javascript:void(0);"}> {product.ProductDisplayName}</a>
                                            }
                                        >
                                            <a
                                                className="hyperlink"
                                                href={"javascript:void(0);"}
                                                onClick={() => {
                                                    this.addEvent({
                                                        eventParameters: {
                                                            eventCategory: eventCategoryForGTM.summaryTab,
                                                            eventAction: "product details",
                                                            eventLabel: product.ProductDisplayName,
                                                        },
                                                        event: "summarytab_interaction",
                                                    });
                                                    window.location.assign(StaticUrls.SippDetail(product.ClAccountId));
                                                }}
                                            >
                                                {product.ProductDisplayName}
                                            </a>
                                        </Permission>
                                    )}
                                    <span className="account">{product.ClAccountId}</span>
                                </div>
                                {this.renderDotsDropdown(product)}
                            </div>
                        </div>
                        <div className="card-content">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Value</th>
                                        <th className="cell-right text-highlight value">
                                            {Methods.getMoneyFormat(
                                                product.TotalValue.Currency == CurrencyCode.NotSpecified &&
                                                    product.TotalValue.Amount == 0
                                                    ? { Amount: 0, Currency: CurrencyCode.GBP }
                                                    : product.TotalValue
                                            )}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>{this.renderTableBody(product)}</tbody>
                            </table>
                        </div>
                    </div>
                </div>
                {this.renderInvestmentDetailPopupModal(product.ProductDisplayName)}
                {this.state.showLightbox && (
                    <Lightbox
                        show={this.state.showLightbox}
                        title={""}
                        contentAfterTitle={null}
                        onClose={() => this.setState({ showLightbox: false })}
                        type={LightboxType.Modal}
                        unclosable={true}
                        noOverlay={false}
                        noAutofocus={true}
                        cssWrapper="is-default-lightbox is-narrow"
                    >
                        <p>If you wish to take a withdrawal from a bond, please contact the Wrap Customer Centre.</p>
                        <button className="btn primary" onClick={() => this.setState({ showLightbox: false })}>
                            OK
                        </button>
                    </Lightbox>
                )}
                {this.state.showWithDrawlRestrictionLightbox && (
                    <Lightbox
                        show={this.state.showWithDrawlRestrictionLightbox}
                        title={""}
                        contentAfterTitle={null}
                        onClose={() => this.setState({ showWithDrawlRestrictionLightbox: false })}
                        type={LightboxType.Modal}
                        unclosable={true}
                        noOverlay={false}
                        noAutofocus={true}
                        cssWrapper="is-default-lightbox is-narrow"
                    >
                        <p>{"An account with suspended or restricted activities cannot setup withdrawals."}</p>
                        <button
                            className="btn primary"
                            onClick={() => this.setState({ showWithDrawlRestrictionLightbox: false })}
                        >
                            OK
                        </button>
                    </Lightbox>
                )}
            </div>
        );
    }

    private getWithDrawalRestrictionActive(valuation: ProductValuationDetailSummary): boolean {
        return false;
    }

    private renderDotsDropdown(product: ProductValuationDetailSummary) {
        const clAccountId = product.ClAccountId;
        const subAccount = (ClientAccountStore.getClientAccountInfo()?.SubAccounts || []).filter(
            (ele) => ele.ClAccountId == clAccountId
        );
        const subAccountHierarchyId = CommonHelper.isNullOrEmpty(product.SubAccountHierarchyId)
            ? subAccount.length > 0
                ? subAccount[0].HierarchyId
                : ""
            : product.SubAccountHierarchyId;
        const headAccountHierarchyId = CommonHelper.isNullOrEmpty(product.HeadAccountHierarchyId)
            ? getQueryParameters()["hierarchyid"]
            : product.HeadAccountHierarchyId;

        return (
            <div className="col-1" style={{ position: "relative" }}>
                {this.props.index === 0 && <CoachMarker coachMarkerKey="portfoliosummary-actions" />}
                <div style={{ position: "absolute", right: "-26px" }}>
                    {!UserStore.getUserInfo()?.IsReadOnly && this.props.hasReadWriteAccessToAdviser == true && (
                        <ThreeDotsDrodpwn
                            isAppStoreEnabled={this.state.userInfo?.IsAppStoreEnabledForUser}
                            data={product}
                            headAccountHierarchyId={headAccountHierarchyId}
                            subAccountHierarchyId={subAccountHierarchyId}
                            regularPaymentsIn={product.RegularPaymentIns.length > 0}
                            isWithDrawalRestriction={this.getWithDrawalRestrictionActive(product)}
                            restrictWithdrawal={() => this.setState({ showWithDrawlRestrictionLightbox: true })}
                            prohibitedWithdrawal={() => this.setState({ showLightbox: true })}
                            trustDetail={this.state.trustDetail.find(
                                (ele) => ele.ClAccountId == this.props.product?.ClAccountId.split("-")[0]
                            )}
                            buttonTitle={"Account quick action menu"}
                            restrictionReasons={this.state?.restrictionReasons}
                        />
                    )}
                </div>
            </div>
        );
    }

    private getLatestPaymentsIn = (source: string, data: RegularPaymentIn[]) => {
        if (!data) {return null;}
        const paymentsIn = data.filter((ele) => ele.Source?.toLowerCase() == source.toLowerCase());
        if (paymentsIn.length == 0) {return null;}
        if (paymentsIn.length == 1) {return paymentsIn;}
        paymentsIn.sort((a, b) => (JsonDateParser.toDate(a.FirstDate) > JsonDateParser.toDate(b.FirstDate) ? -1 : 1));
        return paymentsIn;
    };

    private renderTableBody(product: ProductValuationDetailSummary): JSX.Element[] {
        let element: JSX.Element[] = [];
        const { sippDrawdownServiceFailure, sippIncome } = this.state;
        const payment: Array<RegularPaymentIn> = product.RegularPaymentIns;
        const clientRegularPayment = this.getLatestPaymentsIn("individual", payment);
        const thirdPartyRegularPayment = this.getLatestPaymentsIn("3rdparty", payment);
        const employerRegularPayment = this.getLatestPaymentsIn("employer", payment);
        const salaryRegularPayment = this.getLatestPaymentsIn("individual salary deduction", payment);
        const employerSalaryRegularPayment = this.getLatestPaymentsIn("EmployerSalaryDeduction", payment);
        const isaAllowance = product.AllowanceRemaining;
        const withdrawal = product.RegularWithdraws;
        const isOnPlatformPension = SubAccountTypeHelper.isOnPlatformPension(product.ProductType);
        const isISAStock = product.ProductType === SubAccountType.StocksIsa;
        const isSIPP = SubAccountTypeHelper.isSIPP(product.ProductType);
        const isOffPlatformPension = SubAccountTypeHelper.isOffPlatformPension(product.ProductType);
        const isBond =
            product.ProductType === SubAccountType.OnshoreBond || product.ProductType === SubAccountType.OffshoreBond;
        let isRenderWithDraw = false;

        if (!isBond && !isOffPlatformPension && !isOnPlatformPension) {
            element = this.RenderRegularPaymentIn(
                element,
                clientRegularPayment,
                DashboardContents.ClientRegularPaymentIn,
                true
            );
            element = this.RenderRegularPaymentIn(
                element,
                thirdPartyRegularPayment,
                DashboardContents.ThirdPartyRegularPaymentIn
            );
        }
        if (isBond) {
            element = this.RenderRegularPaymentIn(
                element,
                clientRegularPayment,
                DashboardContents.ClientRegularPaymentIn,
                true
            );
        }
        if (isISAStock) {
            element = this.RenderRegularWithdraw(element, withdrawal);
            isRenderWithDraw = true;

            element.push(
                this.renderTableCol(
                    DashboardContents.ISAAllowanceRemaining,
                    DashboardContents.ISAAllowanceRemaining,
                    this.getValue(isaAllowance.Amount, "allowance"),
                    DashboardContents.zeroValue
                )
            );
        }
        if (isOnPlatformPension) {
            element = this.RenderRegularPaymentIn(
                element,
                clientRegularPayment,
                DashboardContents.ClientRegularPaymentIn,
                true
            );
            element = this.RenderRegularPaymentIn(
                element,
                employerRegularPayment,
                DashboardContents.EmployerRegularPaymentIn
            );
            element = this.RenderRegularPaymentIn(
                element,
                thirdPartyRegularPayment,
                DashboardContents.ThirdPartyRegularPaymentIn
            );
            element = this.RenderRegularPaymentIn(
                element,
                employerSalaryRegularPayment,
                DashboardContents.IndividualSDRegularPaymentIn
            );

            const hasIncomePayment = this.hasNextIncomepayment(this.state.drawdownIncome?.AnnualIncome);
            const incomeValue = hasIncomePayment ?  Methods.getMoneyFormat(calculateGrossIncomePerPayment(this.state.drawdownIncome?.AnnualIncome)): null;
            const incomeFrequency = hasIncomePayment ? FrequencyTypeMap[this.state.drawdownIncome?.AnnualIncome?.Frequency] : null
            
            element.push(
                this.renderTableCol(
                    DashboardContents.onPlatformPensionIncomePayment,
                    DashboardContents.onPlatformPensionIncomePayment,
                    incomeValue,
                    DashboardContents.None,
                    incomeFrequency
                )
            );
        }
        //sipp
        if (isOffPlatformPension) {
            const incomeValue = sippDrawdownServiceFailure
                ? DashboardContents.ServiceDown
                : this.getValue(sippIncome?.CurrentIncome, "income");
            const incomeFrequency = sippDrawdownServiceFailure
                ? null
                : this.getFrequency(sippIncome?.IncomeFrequency, "income");

            element = this.RenderRegularPaymentIn(
                element,
                clientRegularPayment,
                DashboardContents.ClientRegularPaymentIn,
                true
            );
            element = this.RenderRegularPaymentIn(
                element,
                employerRegularPayment,
                DashboardContents.EmployerRegularPaymentIn
            );
            element = this.RenderRegularPaymentIn(
                element,
                thirdPartyRegularPayment,
                DashboardContents.ThirdPartyRegularPaymentIn
            );
            element = this.RenderRegularPaymentIn(
                element,
                salaryRegularPayment,
                DashboardContents.IndividualSDRegularPaymentIn
            );

            element.push(
                this.renderTableCol(
                    DashboardContents.nextRegularIncomePayment,
                    DashboardContents.IncomePayment,
                    incomeValue,
                    DashboardContents.None,
                    incomeFrequency
                )
            );
        }

        if (!isRenderWithDraw && !isSIPP) {
            element = this.RenderRegularWithdraw(element, withdrawal);
        }

        if (isOffPlatformPension || isBond) {
            const headAccount = PortfolioDashboardStore.getData().find((ele) => ele.HierarchyId == product.HeadAccountHierarchyId)
            const subAccount = (headAccount?.SubAccounts || []).find(
                (ele) => ele.ClAccountId == product.ClAccountId
            );
            let status = subAccount?.Status;
            if (isBond && !status) {
                status = product.IsAvailable ? AccountStatus.Active : AccountStatus.InActive;
            }
            element.push(
                <tr key={"Status_" + product.ClAccountId + Guid.getNext()}>
                    <td>Status</td>
                    <td className="cell-right text-highlight">{accountStatusMap[status]?.split(": ")[1]}</td>
                </tr>
            );
            let inceptionDate =
                subAccount?.InceptionDate?.toString() == InvalidateDate
                    ? ClientAccountStore.getClientAccountInfo()?.InceptionDate
                    : subAccount?.InceptionDate;
            if (isBond && !inceptionDate) {
                inceptionDate = product.InceptionDate;
            }
            element.push(
                <tr key={"Status_" + product.ClAccountId + Guid.getNext()}>
                    <td>Inception Date</td>
                    <td className="cell-right text-highlight">
                        {JsonDateParser.getFormatDate(inceptionDate, "dd/MM/yyyy")}
                    </td>
                </tr>
            );
        }

        let availableValue = 0;
        if (product.PortfolioCashDetail.length > 0) {
            const availableGBP = product.PortfolioCashDetail.filter((x) => x.CurrencyCode === CurrencyCode.GBP);
            if (availableGBP) {
                availableValue = availableGBP[0].AvailBalance;
            }
        }

        element.push(
            <tr key={"Transactions_" + product.ClAccountId + Guid.getNext()}>
                <td>Cash available</td>
                <td className="cell-right text-highlight">
                    <a
                        className="hyperlink"
                        onClick={() => {
                            this.addEvent({
                                event: "summarytab_interaction",
                                eventParameters: {
                                    eventCategory: eventCategoryForGTM.summaryTab,
                                    eventAction: "cash available",
                                    eventLabel: product.ProductDisplayName,
                                },
                            });
                            this.popupCashView(product.ClAccountId, availableValue, product.SubAccountHierarchyId);
                        }}
                    >
                        {availableValue == 0
                            ? DashboardContents.None
                            : Methods.getMoneyFormat({ Amount: availableValue, Currency: CurrencyCode.GBP }, false)}
                    </a>
                </td>
            </tr>
        );

        return element;
    }

    private RenderRegularPaymentIn(element, regularPaymentIn, dashboardContents, renderNone = false) {
        if (regularPaymentIn?.length > 0) {
            regularPaymentIn?.forEach((ele) =>
                element.push(
                    this.renderTableCol(
                        dashboardContents,
                        dashboardContents,
                        this.getValue(ele, "paymentin"),
                        DashboardContents.None,
                        this.getFrequency(ele, "paymentin")
                    )
                )
            );
        } else {
            if (renderNone) {
                element.push(this.renderTableCol(dashboardContents, dashboardContents, null, DashboardContents.None));
            }
        }

        return element;
    }
    private RenderRegularWithdraw(element, withdrawal) {
        if (withdrawal.InternalMessages.length > 0) {
            element = element.concat(
                this.renderTableColSet(
                    null,
                    DashboardContents.nextRegularWithdrawal,
                    DashboardContents.ServiceDown,
                    true,
                    "withdrawal"
                )
            );
        } else {
            element = element.concat(
                this.renderTableColSet(
                    withdrawal.RegularWithdraws,
                    DashboardContents.nextRegularWithdrawal,
                    DashboardContents.None,
                    true,
                    "withdrawal"
                )
            );
        }
        return element;
    }
    
    private renderTableColSet(
        data: Array<any>,
        title: string,
        noneContent: string,
        needFrequency: boolean,
        type: string
    ): JSX.Element[] {
        const elements = [];
        if (data && data.length > 0) {
            data.forEach((el, index) => {
                const value = this.getValue(el, type);
                const key = title + index;
                const frequency = needFrequency ? this.getFrequency(el, type) : null;
                elements.push(this.renderTableCol(key, title, value, noneContent, frequency));
            });
        } else {
            elements.push(
                <tr key={title + "_" + Guid.getNext()}>
                    <td>{title}</td>
                    <td className="cell-right text-highlight">{noneContent}</td>
                </tr>
            );
        }
        return elements;
    }

    private renderTableCol(
        key: string,
        title: string,
        value: string,
        noneContent: string,
        frequency?: string
    ): JSX.Element {
        let valueContent = null;
        if (!value) {
            valueContent = noneContent;
        } else {
            valueContent = frequency ? (
                <span>
                    <span>{value}</span>
                    &nbsp;
                    <small className="text-lower">{frequency}</small>
                </span>
            ) : (
                value
            );
        }
        return (
            <tr key={key + "_" + Guid.getNext()}>
                <td>{title}</td>
                <td className="cell-right text-highlight">{valueContent}</td>
            </tr>
        );
    }

    private renderInvestmentDetailPopupModal(productName: string): JSX.Element {
        const { isShowCashModal, hierarchyId } = this.state;

        if (isShowCashModal) {
            return (
                <CashPopupView
                    showBox={isShowCashModal}
                    onChange={() => {
                        this.setState({ isShowCashModal: false });
                    }}
                    productName={productName}
                    accountSelectValue={hierarchyId}
                ></CashPopupView>
            );
        } else {
            return null;
        }
    }

    private getValue(data: any, type: string): string {
        if (!data) {return null;}
        if (type.toLowerCase() == "allowance") {
            if (data && data >= 0) {
                return Methods.getMoneyFormat({ Amount: data as number, Currency: CurrencyCode.GBP });
            }
            return Methods.getMoneyFormat({ Amount: 0, Currency: CurrencyCode.GBP });
        }
        if (type.toLowerCase() == "income") {
            if (data && data.Amount != 0) {
                return Methods.getMoneyFormat(data as Money);
            }
            return null;
        }
        if (type.toLowerCase() == "paymentin") {
            return (data as RegularPaymentIn).RegularPaymentType === RegularPaymentType.Amount
                ? Methods.getMoneyFormat({ Amount: data.Amount, Currency: CurrencyCode.GBP }, false)
                : Methods.getPercentageFormat(data.Percentage);
        }
        if (type.toLowerCase() == "withdrawal") {
            return (data as RegularWithdraw).RegularPaymentType === RegularPaymentType.Amount
                ? Methods.getMoneyFormat({ Amount: data.Amount, Currency: CurrencyCode.GBP }, false)
                : Methods.getPercentageFormat(data.Percentage);
        }
    }

    private getFrequency(data: any, type: string): string {
        if (type.toLocaleLowerCase() === "income") {
            return Methods.getFormatFrequencyType(data as FrequencyType);
        }
        if (type.toLowerCase() == "paymentin") {
            return Methods.getFormatFrequencyType((data as RegularPaymentIn).Frequency);
        }
        if (type.toLowerCase() == "withdrawal") {
            return Methods.getFormatFrequencyType((data as RegularPaymentIn).Frequency);
        }
    }

    private popupCashView(clAccountId: string, availableValue: number, hierarchyId: string) {
        const clientAccountInfo = ClientAccountStore.getClientAccountInfo();
        const subAccountHierarchyId = CommonHelper.isNullOrEmpty(hierarchyId)
            ? clientAccountInfo.SubAccounts.filter((x) => x.ClAccountId == clAccountId)[0].HierarchyId
            : hierarchyId;
        this.setState({
            hierarchyId: subAccountHierarchyId,
            isShowCashModal: true,
        });
    }

    private hasNextIncomepayment = (income: DrawdownAnnualIncome) => {
        return (
            income?.GrossIncomePerPayment?.Amount > 0 ||
            income?.AnnualAmount?.Amount?.Amount > 0 ||
            income?.CurrentYearIncome?.Amount > 0
        );
    };
}
AccountCard.contextType = PresentationContext;
